/**
 * Presets - Patterns de démonstration
 * Patterns originaux inspirés du style acid house
 * et hommages aux classiques du genre
 */

export const PRESETS = {
    // ========================================
    // CLASSIQUES ACID - Inspirés par les légendes
    // ========================================

    // Inspiré par Phuture - Acid Tracks (1987)
    // Le tout premier acid track - hypnotique et minimaliste
    'Style Phuture 87': {
        bass1: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        bass1Notes: ['C2', 'C2', 'C2', 'C2', 'D#2', 'D#2', 'D#2', 'D#2', 'C2', 'C2', 'C2', 'C2', 'G2', 'G2', 'F2', 'F2'],
        bass1Accent: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        bass1Slide: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, true, false],
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        synths: {
            tb303_1: { cutoff: 800, resonance: 18, envMod: 2500, decay: 0.25, accentLevel: 0.6, waveform: 'sawtooth', distortion: 0.15 }
        }
    },

    // Inspiré par A Guy Called Gerald - Voodoo Ray (1988)
    // Acid house UK - plus mélodique et groovy
    'Style Voodoo 88': {
        bass1: [true, false, false, true, false, false, true, false, true, false, false, true, false, true, false, false],
        bass1Notes: ['A2', 'A2', 'A2', 'C3', 'A2', 'A2', 'E2', 'A2', 'A2', 'A2', 'A2', 'G2', 'A2', 'D3', 'A2', 'A2'],
        bass1Accent: [true, false, false, true, false, false, false, false, true, false, false, false, false, true, false, false],
        bass1Slide: [false, false, false, true, false, false, false, false, false, false, false, true, false, true, false, false],
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh: [false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, true],
        // Paramètres synth: son mélodique et chaud
        synths: {
            tb303_1: { cutoff: 1200, resonance: 14, envMod: 2000, decay: 0.18, accentLevel: 0.5, waveform: 'sawtooth' }
        }
    },

    // Inspiré par Josh Wink - Higher State (1995)
    // Acid techno frénétique - beaucoup de notes et slides
    'Style Higher State': {
        bass1: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        bass1Notes: ['C2', 'C2', 'G2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'C2', 'C2', 'A#2', 'C2', 'C2', 'F2', 'G2', 'C3'],
        bass1Accent: [true, false, true, false, true, true, false, false, true, false, true, false, true, true, true, true],
        bass1Slide: [false, false, true, false, false, true, false, false, false, false, true, false, false, true, true, false],
        kick: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, true],
        hihat: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh: [false, false, false, true, false, false, false, true, false, false, false, true, false, false, false, true],
        // Paramètres synth: acid agressif et criard
        synths: {
            tb303_1: { cutoff: 600, resonance: 22, envMod: 3500, decay: 0.12, accentLevel: 0.8, waveform: 'sawtooth' }
        }
    },

    // Inspiré par Aphex Twin - Style Analord/Caustic Window
    // Acid expérimental - patterns inhabituels, déséquilibrés
    'Style AFX Acid': {
        bass1: [true, false, true, true, false, true, false, false, true, true, false, true, false, false, true, false],
        bass1Notes: ['C2', 'C2', 'E2', 'G2', 'C2', 'A#2', 'C2', 'C2', 'D2', 'F2', 'C2', 'G#2', 'C2', 'C2', 'B2', 'C2'],
        bass1Accent: [true, false, false, true, false, true, false, false, false, true, false, true, false, false, true, false],
        bass1Slide: [false, false, true, true, false, false, false, false, true, true, false, false, false, false, true, false],
        bass2: [false, true, false, false, true, false, true, false, false, false, true, false, true, true, false, true],
        bass2Notes: ['G3', 'G3', 'G3', 'G3', 'D3', 'G3', 'A#3', 'G3', 'G3', 'G3', 'F3', 'G3', 'E3', 'G3', 'G3', 'C4'],
        bass2Accent: [false, false, false, false, true, false, false, false, false, false, true, false, false, true, false, true],
        bass2Slide: [false, false, false, false, false, false, true, false, false, false, false, false, true, false, false, true],
        kick: [true, false, false, true, false, false, true, false, false, true, false, false, true, false, true, false],
        snare: [false, false, false, false, true, false, false, true, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, true, false, true, true, false, true, false, true, true, false, true, false, true],
        openhh: [false, false, false, false, false, false, false, true, false, false, false, false, false, false, true, false],
        // Paramètres synth: son expérimental avec deux 303 contrastées
        synths: {
            tb303_1: { cutoff: 900, resonance: 20, envMod: 3000, decay: 0.15, accentLevel: 0.7, waveform: 'sawtooth' },
            tb303_2: { cutoff: 2000, resonance: 10, envMod: 1500, decay: 0.1, accentLevel: 0.4, waveform: 'square' }
        }
    },

    // Inspiré par Aphex Twin - Style Didgeridoo/Digeridoo
    // Très rapide, tribal, hypnotique
    'Style AFX Tribal': {
        bass1: [true, true, false, true, true, false, true, false, true, true, false, true, true, false, true, true],
        bass1Notes: ['C2', 'C2', 'C2', 'C2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'C2', 'C2', 'C2', 'C2', 'C2', 'G2', 'D#2'],
        bass1Accent: [true, false, false, true, false, false, true, false, true, false, false, true, false, false, true, true],
        bass1Slide: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        kick: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        // Paramètres synth: son didgeridoo/drone grave
        synths: {
            tb303_1: { cutoff: 500, resonance: 25, envMod: 2000, decay: 0.3, accentLevel: 0.6, waveform: 'sawtooth' },
            tr808: { kickDecay: 0.35, kickTone: 45, snareSnappy: 0.3, hhDecay: 0.05 }
        }
    },

    // Inspiré par Aphex Twin - Style ambiant/mélodique (Selected Ambient)
    // Plus lent, atmosphérique, deux 303 en harmonie
    'Style AFX Ambient': {
        bass1: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        bass1Notes: ['A2', 'A2', 'A2', 'A2', 'E2', 'A2', 'A2', 'A2', 'A2', 'A2', 'A2', 'A2', 'D2', 'A2', 'A2', 'A2'],
        bass1Accent: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        bass1Slide: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        bass2: [false, false, true, false, false, false, true, false, false, false, true, false, false, false, true, false],
        bass2Notes: ['E3', 'E3', 'E3', 'E3', 'E3', 'E3', 'A3', 'E3', 'E3', 'E3', 'C3', 'E3', 'E3', 'E3', 'D3', 'E3'],
        bass2Accent: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        bass2Slide: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        kick: [true, false, false, false, false, false, false, false, true, false, false, false, false, false, false, false],
        snare: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        hihat: [false, false, true, false, false, false, true, false, false, false, true, false, false, false, true, false],
        openhh: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        // Paramètres synth: son doux et ambient
        synths: {
            tb303_1: { cutoff: 1800, resonance: 8, envMod: 1000, decay: 0.4, accentLevel: 0.2, waveform: 'sawtooth' },
            tb303_2: { cutoff: 2500, resonance: 6, envMod: 800, decay: 0.5, accentLevel: 0.3, waveform: 'square' },
            tr808: { kickDecay: 0.7, kickTone: 55, snareSnappy: 0.2, hhDecay: 0.15 }
        }
    },

    // ========================================
    // PATTERNS GÉNÉRIQUES
    // ========================================

    // Pattern acid classique avec slides
    'Acid Basic': {
        bass1: [true, false, false, true, true, false, true, false, true, false, false, true, true, false, true, false],
        bass1Notes: ['C2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'G2', 'C2', 'C2', 'C2', 'C2', 'F2', 'C2', 'C2', 'A#2', 'C2'],
        bass1Accent: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        bass1Slide: [false, false, false, true, false, false, true, false, false, false, false, true, false, false, true, false],
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false]
    },

    // Pattern plus agressif avec beaucoup d'accents
    'Acid Rave': {
        bass1: [true, true, false, true, true, false, true, true, true, true, false, true, true, false, true, true],
        bass1Notes: ['C2', 'C3', 'C2', 'G2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'C3', 'C2', 'F2', 'C2', 'C2', 'G2', 'A#2'],
        bass1Accent: [true, true, false, false, true, false, true, false, true, true, false, false, true, false, true, true],
        bass1Slide: [false, true, false, false, false, false, true, false, false, true, false, false, false, false, true, false],
        kick: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        snare: [false, false, false, false, true, false, false, true, false, false, false, false, true, false, false, true],
        hihat: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh: [false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, true],
        // Paramètres synth: agressif et criard
        synths: {
            tb303_1: { cutoff: 700, resonance: 24, envMod: 4000, decay: 0.1, accentLevel: 0.9, waveform: 'sawtooth' }
        }
    },

    // Pattern minimaliste hypnotique
    'Hypnotic': {
        bass1: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        bass1Notes: ['C2', 'C2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'C2', 'C2', 'C2', 'C2', 'C2', 'G2', 'C2', 'C2', 'C2'],
        bass1Accent: [true, false, false, false, false, false, false, false, true, false, false, false, false, false, false, false],
        bass1Slide: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        bass2: [false, false, true, false, false, false, true, false, false, false, true, false, false, false, true, false],
        bass2Notes: ['G3', 'G3', 'G3', 'G3', 'G3', 'G3', 'A#3', 'G3', 'G3', 'G3', 'G3', 'G3', 'G3', 'G3', 'C4', 'G3'],
        bass2Accent: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        bass2Slide: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, false],
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, false]
    },

    // Pattern dual 303 (les deux basses)
    'Dual Acid': {
        bass1: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        bass1Notes: ['C2', 'C2', 'D#2', 'C2', 'F2', 'C2', 'G2', 'C2', 'C2', 'C2', 'D#2', 'C2', 'F2', 'C2', 'A#2', 'C2'],
        bass1Accent: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, true, false],
        bass1Slide: [false, false, true, false, false, false, true, false, false, false, true, false, false, false, true, false],
        bass2: [false, true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
        bass2Notes: ['C3', 'C3', 'C3', 'G3', 'C3', 'C3', 'C3', 'D#3', 'C3', 'C3', 'C3', 'F3', 'C3', 'C3', 'C3', 'G3'],
        bass2Accent: [false, false, false, true, false, false, false, true, false, false, false, true, false, false, false, true],
        bass2Slide: [false, false, false, true, false, false, false, true, false, false, false, true, false, false, false, false],
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false]
    },

    // Pattern breakbeat style
    'Acid Break': {
        bass1: [true, false, false, true, false, false, true, false, false, true, false, false, true, false, true, false],
        bass1Notes: ['C2', 'C2', 'C2', 'G2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'F2', 'C2', 'C2', 'C2', 'C2', 'A#2', 'C2'],
        bass1Accent: [true, false, false, true, false, false, false, false, false, true, false, false, true, false, true, false],
        bass1Slide: [false, false, false, true, false, false, false, false, false, true, false, false, false, false, true, false],
        kick: [true, false, false, false, false, false, true, false, false, false, true, false, false, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, true, false, false, true, false, false, false],
        hihat: [true, false, true, true, false, true, true, false, true, false, true, true, false, true, true, false],
        openhh: [false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, true]
    },

    // ========================================
    // MINIMOOG - Basses grasses et leads
    // ========================================

    // Fat Moog Bass - Son gras typique Minimoog
    'Fat Moog Bass': {
        // Minimoog fait la basse
        minimoogNotes: ['C2', 'C2', 'C2', 'G2', 'C2', 'C2', 'D#2', 'D#2', 'C2', 'C2', 'C2', 'F2', 'C2', 'G2', 'A#2', 'C2'],
        minimoogGates: [true, false, false, true, false, true, true, false, true, false, false, true, false, true, true, false],
        // 808 kick lourd pour accompagner
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        synths: {
            minimoog: {
                osc1Waveform: 'sawtooth', osc1Octave: 0, osc1Tune: 0, osc1Level: 0.9,
                osc2Waveform: 'sawtooth', osc2Octave: 0, osc2Tune: 7, osc2Level: 0.7,
                osc3Waveform: 'square', osc3Octave: -1, osc3Tune: 0, osc3Level: 0.5,
                noiseLevel: 0,
                cutoff: 800, resonance: 8, filterEnvAmount: 0.6, filterKeyTrack: 0.3,
                filterAttack: 0.005, filterDecay: 0.4, filterSustain: 0.3,
                ampAttack: 0.005, ampDecay: 0.3, ampSustain: 0.8, ampRelease: 0.2,
                glide: 0.08, volume: 0.8
            },
            tr808: { kickDecay: 0.5, kickTone: 50, snareSnappy: 0.4, hhDecay: 0.08 }
        }
    },

    // Moog Lead - Son de lead acid avec Minimoog + 303
    'Moog Lead Acid': {
        // 303 fait la ligne basse acide
        bass1: [true, false, false, true, true, false, true, false, true, false, false, true, true, false, true, false],
        bass1Notes: ['C2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'G2', 'C2', 'C2', 'C2', 'C2', 'F2', 'C2', 'C2', 'A#2', 'C2'],
        bass1Accent: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        bass1Slide: [false, false, false, true, false, false, true, false, false, false, false, true, false, false, true, false],
        // Minimoog fait le lead par dessus
        minimoogNotes: ['C4', 'C4', 'G3', 'G3', 'D#4', 'D#4', 'C4', 'C4', 'F4', 'F4', 'D#4', 'D#4', 'G4', 'G4', 'A#4', 'C5'],
        minimoogGates: [true, false, true, false, true, false, false, true, true, false, true, false, true, false, true, true],
        kick909: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare909: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hh909: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh909: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        synths: {
            tb303_1: { cutoff: 600, resonance: 22, envMod: 3000, decay: 0.15, accentLevel: 0.7, waveform: 'sawtooth' },
            minimoog: {
                osc1Waveform: 'sawtooth', osc1Octave: 0, osc1Tune: 0, osc1Level: 0.8,
                osc2Waveform: 'square', osc2Octave: 0, osc2Tune: -5, osc2Level: 0.6,
                osc3Waveform: 'sawtooth', osc3Octave: 1, osc3Tune: 7, osc3Level: 0.4,
                noiseLevel: 0.02,
                cutoff: 3000, resonance: 6, filterEnvAmount: 0.4, filterKeyTrack: 0.5,
                filterAttack: 0.01, filterDecay: 0.2, filterSustain: 0.5,
                ampAttack: 0.01, ampDecay: 0.15, ampSustain: 0.7, ampRelease: 0.15,
                glide: 0.05, volume: 0.6
            },
            tr909: { kickAttack: 0.6, kickTune: 55, snareSnappy: 0.6 }
        }
    },

    // ========================================
    // 909 TECHNO
    // ========================================

    // Pattern techno classique avec 909
    '909 Techno': {
        bass1: [true, false, false, true, false, false, true, false, true, false, false, true, false, true, false, false],
        bass1Notes: ['C2', 'C2', 'C2', 'G2', 'C2', 'C2', 'D#2', 'C2', 'C2', 'C2', 'C2', 'F2', 'C2', 'A#2', 'C2', 'C2'],
        bass1Accent: [true, false, false, false, false, false, true, false, true, false, false, false, false, true, false, false],
        bass1Slide: [false, false, false, true, false, false, false, false, false, false, false, true, false, false, false, false],
        kick909: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare909: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        clap909: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, true],
        hh909: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh909: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        ride909: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
        synths: {
            tb303_1: { cutoff: 600, resonance: 20, envMod: 3000, decay: 0.15, accentLevel: 0.7, waveform: 'sawtooth', distortion: 0.3 },
            tr909: { kickAttack: 0.7, kickTune: 55, snareSnappy: 0.6 }
        }
    },

    // Pattern 808 + 909 combinés
    '808 + 909 Combo': {
        bass1: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        bass1Notes: ['C2', 'C2', 'D#2', 'C2', 'C2', 'C2', 'G2', 'C2', 'C2', 'C2', 'F2', 'C2', 'C2', 'C2', 'A#2', 'G2'],
        bass1Accent: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, true, false],
        bass1Slide: [false, false, true, false, false, false, true, false, false, false, true, false, false, false, true, true],
        // 808 pour les basses fréquences
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        lowtom: [false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, true],
        // 909 pour les hautes fréquences
        snare909: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        clap909: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, false],
        hh909: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh909: [false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, true],
        cowbell: [false, false, true, false, false, false, true, false, false, false, true, false, false, false, true, false],
        synths: {
            tb303_1: { cutoff: 900, resonance: 18, envMod: 2500, decay: 0.18, accentLevel: 0.6, waveform: 'sawtooth', distortion: 0.2 },
            tr808: { kickDecay: 0.6, kickTone: 45 },
            tr909: { kickAttack: 0.5, snareSnappy: 0.7 }
        }
    },

    // Pattern vide pour repartir de zéro
    'Empty': {
        bass1: Array(16).fill(false),
        bass1Notes: Array(16).fill('C2'),
        bass1Accent: Array(16).fill(false),
        bass1Slide: Array(16).fill(false),
        bass2: Array(16).fill(false),
        bass2Notes: Array(16).fill('C3'),
        bass2Accent: Array(16).fill(false),
        bass2Slide: Array(16).fill(false),
        kick: Array(16).fill(false),
        snare: Array(16).fill(false),
        hihat: Array(16).fill(false),
        openhh: Array(16).fill(false),
        clap: Array(16).fill(false),
        rimshot: Array(16).fill(false),
        lowtom: Array(16).fill(false),
        midtom: Array(16).fill(false),
        hitom: Array(16).fill(false),
        cowbell: Array(16).fill(false),
        kick909: Array(16).fill(false),
        snare909: Array(16).fill(false),
        clap909: Array(16).fill(false),
        rimshot909: Array(16).fill(false),
        hh909: Array(16).fill(false),
        openhh909: Array(16).fill(false),
        ride909: Array(16).fill(false),
        crash909: Array(16).fill(false),
        minimoogNotes: Array(16).fill('C2'),
        minimoogGates: Array(16).fill(false),
        ms20Notes: Array(16).fill('C2'),
        ms20Gates: Array(16).fill(false)
    },

    // ========================================
    // KORG MS-20 - Sons industriels et agressifs
    // ========================================

    // MS-20 Screaming Lead - Le filtre qui crie!
    'MS-20 Screaming': {
        // MS-20 fait le lead agressif avec filtre qui crie
        ms20Notes: ['C3', 'C3', 'G3', 'G3', 'C3', 'D#3', 'F3', 'F3', 'C3', 'C3', 'A#3', 'G3', 'C3', 'D#3', 'G3', 'C4'],
        ms20Gates: [true, false, true, false, true, true, true, false, true, false, true, true, true, true, true, true],
        // 909 kick punchy
        kick909: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare909: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hh909: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh909: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        synths: {
            ms20: {
                vco1Waveform: 'sawtooth', vco1Octave: 0, vco1Level: 0.9,
                vco2Waveform: 'square', vco2Octave: 0, vco2Detune: 7, vco2Level: 0.7,
                ringModLevel: 0.1, noiseLevel: 0.05,
                hpfCutoff: 200, hpfResonance: 5,
                lpfCutoff: 2000, lpfResonance: 22, lpfEnvAmount: 0.8, lpfKeyTrack: 0.6,
                eg1Attack: 0.005, eg1Decay: 0.2, eg1Sustain: 0.3, eg1Release: 0.1,
                eg2Attack: 0.005, eg2Decay: 0.15, eg2Sustain: 0.7, eg2Release: 0.2,
                mgRate: 0, mgPitchAmount: 0, mgFilterAmount: 0,
                portamento: 0.05, volume: 0.7
            },
            tr909: { kickAttack: 0.8, kickTune: 50, snareSnappy: 0.7, hhDecay: 0.04 }
        }
    },

    // MS-20 Industrial Bass - Son gras avec HPF ouvert
    'MS-20 Industrial': {
        // MS-20 basse industrielle
        ms20Notes: ['C1', 'C1', 'C1', 'G1', 'C1', 'C1', 'D#1', 'C1', 'C1', 'C1', 'C1', 'F1', 'C1', 'C1', 'A#1', 'G1'],
        ms20Gates: [true, false, true, true, false, true, true, false, true, false, true, true, false, true, true, true],
        // Ring mod pour du grit
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        clap: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        synths: {
            ms20: {
                vco1Waveform: 'sawtooth', vco1Octave: 0, vco1Level: 1.0,
                vco2Waveform: 'sawtooth', vco2Octave: -1, vco2Detune: -5, vco2Level: 0.8,
                ringModLevel: 0.15, noiseLevel: 0.1,
                hpfCutoff: 100, hpfResonance: 8,
                lpfCutoff: 600, lpfResonance: 15, lpfEnvAmount: 0.7, lpfKeyTrack: 0.2,
                eg1Attack: 0.001, eg1Decay: 0.4, eg1Sustain: 0.2, eg1Release: 0.2,
                eg2Attack: 0.001, eg2Decay: 0.3, eg2Sustain: 0.6, eg2Release: 0.3,
                mgRate: 0, mgPitchAmount: 0, mgFilterAmount: 0,
                portamento: 0.02, volume: 0.85
            },
            tr808: { kickDecay: 0.4, kickTone: 40, snareSnappy: 0.3, hhDecay: 0.06 }
        }
    },

    // MS-20 + 303 Acid Combo - Deux légendes ensemble
    'MS-20 + 303 Acid': {
        // 303 fait l'acid bass
        bass1: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        bass1Notes: ['C2', 'C2', 'D#2', 'C2', 'F2', 'C2', 'G2', 'C2', 'C2', 'C2', 'D#2', 'C2', 'F2', 'C2', 'A#2', 'G2'],
        bass1Accent: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, true, false],
        bass1Slide: [false, false, true, false, false, false, true, false, false, false, true, false, false, false, true, true],
        // MS-20 fait des stabs avec le HPF qui ouvre
        ms20Notes: ['C4', 'C4', 'C4', 'G4', 'C4', 'C4', 'C4', 'D#4', 'C4', 'C4', 'C4', 'F4', 'C4', 'C4', 'C4', 'A#4'],
        ms20Gates: [false, false, true, false, false, false, true, false, false, false, true, false, false, true, true, false],
        kick909: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare909: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hh909: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
        openhh909: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        synths: {
            tb303_1: { cutoff: 700, resonance: 20, envMod: 3000, decay: 0.12, accentLevel: 0.8, waveform: 'sawtooth', distortion: 0.25 },
            ms20: {
                vco1Waveform: 'square', vco1Octave: 0, vco1Level: 0.8,
                vco2Waveform: 'sawtooth', vco2Octave: 0, vco2Detune: 12, vco2Level: 0.6,
                ringModLevel: 0, noiseLevel: 0,
                hpfCutoff: 500, hpfResonance: 10,
                lpfCutoff: 4000, lpfResonance: 12, lpfEnvAmount: 0.6, lpfKeyTrack: 0.5,
                eg1Attack: 0.001, eg1Decay: 0.1, eg1Sustain: 0.1, eg1Release: 0.05,
                eg2Attack: 0.001, eg2Decay: 0.08, eg2Sustain: 0.4, eg2Release: 0.1,
                mgRate: 0, mgPitchAmount: 0, mgFilterAmount: 0,
                portamento: 0, volume: 0.6
            },
            tr909: { kickAttack: 0.6, kickTune: 55, snareSnappy: 0.65, hhDecay: 0.05 }
        }
    },

    // MS-20 Wobble - LFO sur le filtre
    'MS-20 Wobble': {
        ms20Notes: ['C2', 'C2', 'C2', 'C2', 'G2', 'G2', 'G2', 'G2', 'D#2', 'D#2', 'D#2', 'D#2', 'F2', 'F2', 'G2', 'G2'],
        ms20Gates: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, true, false],
        kick: [true, false, false, false, true, false, false, false, true, false, false, false, true, false, false, false],
        snare: [false, false, false, false, true, false, false, false, false, false, false, false, true, false, false, false],
        hihat: [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true, false],
        openhh: [false, false, false, false, false, false, true, false, false, false, false, false, false, false, true, false],
        synths: {
            ms20: {
                vco1Waveform: 'sawtooth', vco1Octave: 0, vco1Level: 0.9,
                vco2Waveform: 'sawtooth', vco2Octave: 0, vco2Detune: 5, vco2Level: 0.7,
                ringModLevel: 0, noiseLevel: 0,
                hpfCutoff: 50, hpfResonance: 2,
                lpfCutoff: 1500, lpfResonance: 18, lpfEnvAmount: 0.3, lpfKeyTrack: 0.3,
                eg1Attack: 0.01, eg1Decay: 0.5, eg1Sustain: 0.5, eg1Release: 0.3,
                eg2Attack: 0.01, eg2Decay: 0.3, eg2Sustain: 0.8, eg2Release: 0.3,
                mgRate: 4, mgPitchAmount: 0, mgFilterAmount: 0.6,
                portamento: 0.1, volume: 0.75
            },
            tr808: { kickDecay: 0.5, kickTone: 50, snareSnappy: 0.5, hhDecay: 0.08 }
        }
    }
};

export function getPresetNames() {
    return Object.keys(PRESETS);
}

export function getPreset(name) {
    return PRESETS[name] || null;
}
